import FieldConfig from "../../../proto/field-config"
import FieldEstimate from "../../../generic/estimate/estimate"
import ModelEntity from "../../../../model2/model-entity";

export default class FieldProjectEstimateTasks extends FieldEstimate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Project estimate tasks";
        this.label          = _.get(config, 'label', this.typeLabel)

        this.variableName   = "{PROJECT-ESTIMATE-TASKS}"    // used in formulas !
    }

    access(model: any): "read" | "write" | false {
        return "read"
    }

    canEdit(model:ModelEntity):boolean {
        return false
    }


}
